module.exports = __webpack_public_path__ + "static/media/modifyMobile.c29cf180.svg";